import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";

import {View} from "@khanacademy/wonder-blocks-core";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {Roles, SignupForm, StandardSignupLegalBlurb} from "@repo/auth-signup";

import {NewRegistrationHeroFigure} from "./hero-figures.tsx";
import {LohpTwoColumns} from "./lohp-two-column.tsx";

const LohpSignupOverAgeGate = () => {
    return (
        <View style={styles.heroModule}>
            <LohpTwoColumns
                leftComponent={<NewRegistrationHeroFigure />}
                rightComponent={
                    <SignupForm
                        heading={t`Start learning today by signing up!`}
                        nextPath="/signup/extra-info"
                        role={Roles.LEARNER}
                        legalBlurb={<StandardSignupLegalBlurb />}
                        backlinkText={t`Back`}
                        backlinkPath="/lohp/learner"
                    />
                }
                columnTemplate="60% 40%"
            />
        </View>
    );
};

const styles = StyleSheet.create({
    heroModule: {
        paddingTop: spacing.xxxLarge_64,
        alignItems: "center",
        maxWidth: 1200,
        margin: "0 auto",
    },
});

export default LohpSignupOverAgeGate;
